import axios from "axios";

const apiClient = axios.create({
    baseURL: "https://api.themoviedb.org/3",
    headers: {
        accept: 'application/json',
        Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkZjY5MmViM2ZjMjdjZGMwZTg5NjZlM2RkMGFhMjA2MiIsIm5iZiI6MTcyMzE1ODY0Ny42NjExMTksInN1YiI6IjYzMWIxMWMzYWFmZWJkMDA3YTJkNWM3ZCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.s0mR8LVjfno0Oc6oK3y1ZUceNFS-WaYUnmS2X1Y-LKk'
    }

});


export const getPopularKdramas = async (page = 1, filters = {}) => {
    const params = {

        with_original_language: 'ko',  // Filtre par langue coréenne
        page: page,
        with_genres: filters.genre || '18',
        language: 'fr-FR'
    };

    if (filters.keywords) {
        // Join multiple keywords with commas if they exist
        params.with_keywords = filters.keywords.split(',').map(keyword => keyword.trim()).join(',');
    }
    // Prioriser le tri par note s'il est sélectionné
    if (filters.rating) {
        params.sort_by = filters.rating === 'high-to-low' ? 'vote_average.desc' : 'vote_average.asc';

        // Filtrer pour n'inclure que les K-Dramas avec un vote moyen supérieur ou égal à 4 si tri par vote ascendant
        if (filters.rating === 'low-to-high') {
            params['vote_average.gte'] = 4;
        }
    } else {
        // Sinon, trier par popularité
        params.sort_by = 'popularity.desc';
    }

    // Ajouter le filtre par genre
    if (filters.genre) {
        params.with_genres = filters.genre;
    }

    try {
        const response = await apiClient.get('/discover/tv', {
            params: params
        });
        // Pour vérifier les paramètres appliqués
        return response.data;
    } catch (error) {

        throw error;
    }
};

export const getRecentKdrama = async (page = 1, filters = {}) => {
    const params = {
        with_genres: filters.genre || '18',
        with_original_language: 'ko',  // Filtre par langue coréenne
        page: page,
        first_air_date_year: 2024,
        language: 'fr-FR'
    };
    if (filters.keywords) {
        // Join multiple keywords with commas if they exist
        params.with_keywords = filters.keywords.split(',').map(keyword => keyword.trim()).join(',');
    }
    // Prioriser le tri par note s'il est sélectionné
    if (filters.rating) {
        params.sort_by = filters.rating === 'high-to-low' ? 'vote_average.desc' : 'vote_average.asc';

        // Filtrer pour n'inclure que les K-Dramas avec un vote moyen supérieur ou égal à 4 si tri par vote ascendant
        if (filters.rating === 'low-to-high') {
            params['vote_average.gte'] = 4;
        }
    } else {
        // Sinon, trier par popularité
        params.sort_by = 'popularity.desc';
    }

    // Ajouter le filtre par genre
    if (filters.genre) {
        params.with_genres = filters.genre;
    }
    try {
        const response = await apiClient.get('/discover/tv', {
            params: params
        });
        // Pour vérifier les paramètres appliqués
        return response.data;
    } catch (error) {

        throw error;
    }

}



export const getImagesKdramas = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/images`, {

        });
        return response.data;
    } catch (error) {

        throw error;
    }
};


export const getKdramaDetails = async (id) => {

    try {
        const response = await apiClient.get(`/tv/${id}`, {
            params: {
                language: 'fr-FR'
            }
        });
        return response.data;
    } catch (error) {

        throw error;
    }

};

export const getKdramaCredits = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/credits`, {
            params: {
                language: 'en-US'
            }
        })
        return response.data;
    } catch (error) {


        throw error;
    }
};

export const getKdramaCreditAggregates = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/aggregate_credits`, {
            params: {
                language: 'en-US'
            }
        });
        return response.data;
    } catch (error) {

        throw error;
    }
};

export const getKdramaRecommendations = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/recommendations`, {
            params: {
                language: 'fr-FR',

            }
        });
        return response.data;
    } catch (error) {


        throw error;
    }
};

export const getAiringTodayKdramas = async () => {
    try {
        const response = await apiClient.get('/tv/airing_today', {
            params: {
                language: 'fr-FR',
                with_original_language: 'ko'
            }
        });
        return console.log(response.data.results);
    } catch (error) {


        throw error;
    }
};

export const getKdramaVideos = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/videos`, {
            params: {
                include_video_language: 'en-US',
                language: 'fr-FR'
            }
        });
        return response.data.results;
    } catch (error) {

        throw error;
    }
};

export const getKdramaGenres = async () => {
    try {
        const response = await apiClient.get('/genre/tv/list', {
            params: {
                language: 'fr-FR'
            }
        });
        return response.data;
    } catch (error) {


        throw error;
    }
};

export const getWatchProviders = async (id) => {
    try {
        const response = await apiClient.get(`/tv/${id}/watch/providers`);

        return response.data.results;
    } catch (error) {

        throw error;
    }
};

export const getActorDetails = async (id) => {
    try {
        const response = await apiClient.get(`/person/${id}`, {
            params: {
                language: 'en-US'
            }
        });
        return response.data;

    } catch (error) {


        throw error;
    }
};

export const getActorCredits = async (id) => {
    try {
        const response = await apiClient.get(`/person/${id}/tv_credits`, {
            params: {
                language: 'en-US'
            }
        });
        return response.data;
    } catch (error) {

        throw error;
    }
};

export const getSearchKdramas = async (query) => {
    try {
        const response = await apiClient.get('/search/tv', {
            params: {
                language: 'fr-FR',
                query: query
            }
        });

        // Filtrer les résultats pour ne garder que ceux en langue originale coréenne
        const koreanKdramas = response.data.results.filter(kdrama => kdrama.original_language === 'ko');

        return {
            ...response.data,
            results: koreanKdramas
        };
    } catch (error) {

        throw error;
    }
};

export const getSearchActors = async (query) => {
    try {
        const response = await apiClient.get('/search/person', {
            params: {
                language: 'en-US', // Utilisation de l'anglais pour obtenir une liste complète d'acteurs
                query: query
            }
        });

        // Filtrer les acteurs qui sont connus pour des œuvres en coréen
        const actors = response.data.results.filter(actor =>
            actor.known_for.some(work => work.original_language === 'ko')
        );

        return {
            ...response.data,
            results: actors
        };
    } catch (error) {

        throw error;
    }
};

export const getActorImages = async (id) => {
    try {
        const response = await apiClient.get(`/person/${id}/images`)
        return response.data;
    } catch (error) {

        throw error;
    }
};

// export const getTrendingWeekKdrama = async () => {
//     try {

//         const response = await apiClient.get('/trending/tv/week', {
//             params: {
//                 language: 'fr-FR',
//             }
//         });
//         return response.data.results;
//     } catch (error) {
//         console.error('Erreur lors de la recherche de K-dramas:', error);
//         throw error;
//     }
// };